import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/bauDo/menuLink_share_frame.png'
import _imports_1 from '@/assets/bauDo/arrow.png'


const _hoisted_1 = { class: "bauContainer" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "menuLinkCont" }
const _hoisted_4 = { class: "menuLinkWrapper" }
const _hoisted_5 = { class: "menueLinkTxt" }
const _hoisted_6 = { class: "menueLinkBtTxt" }
const _hoisted_7 = {
  style: {"position":"absolute","display":"flex"},
  class: "mediaListMain"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { style: {"color":"#ffffffa6","font-size":"9px"} }
const _hoisted_10 = { style: {"color":"#ffffffd9","font-size":"13.98px"} }
const _hoisted_11 = { style: {"color":"#F0A853","font-size":"15px","display":"flex","justify-content":"flex-end"} }
const _hoisted_12 = { style: {"color":"#F0A853","font-size":"11px","align-items":"center","display":"flex","margin-left":"5px","justify-content":"flex-end"} }
const _hoisted_13 = { style: {"padding-left":"5%"} }
const _hoisted_14 = { class: "bottom_text" }

import { computed, ref } from 'vue';
import InputField from './components/inputField.vue';
import RewardBox from './components/rewardBox.vue';
import { toZigZagWithFlags } from '@/utils/commonFunction';
import CustomHeader from '../components/common/customHeader.vue';
import {MEDIA_LIST, TreasureData } from '@/view/bauDoTesouro/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'bauDoTesouroView',
  props: {
    dataSet: {}
  },
  emits: ['goToShare', 'goToUserDetails'],
  setup(__props: any, { emit: __emit }) {

const mediaList = ref(MEDIA_LIST)

const props = __props

const emits = __emit
const zigzagReordered = computed(() => {
    const chunkSize = 4;
    const raw = [...(props.dataSet.activityConfig?.reward_conf || [])];
    const reordered: any[] = [];

    for (let i = 0; i < raw.length; i += chunkSize * 2) {
        const ltrRaw = raw.slice(i, i + chunkSize);            // left to right
        const rtlRaw = raw.slice(i + chunkSize, i + chunkSize * 2); // right to left (keep order)

        const ltr = ltrRaw.map((item, idx) => ({
            ...item,
            side: 'left',
            turnDown: idx === chunkSize - 1,                          // 4th in left
            isInCorner: idx === 0 || idx === chunkSize - 1           // 1st and 4th in left
        }));

        const rtl = rtlRaw.map((item, idx) => ({
            ...item,
            side: 'right',
            turnDown: idx === 0,                                     // 1st in right (5th overall)
            isInCorner: idx === 0 || idx === rtlRaw.length - 1       // 1st and last in right
        }));

        reordered.push(...ltr, ...rtl);
    }
    return toZigZagWithFlags(reordered, 4);

})


const goToShare = async () => {
   emits('goToShare')
}
const goToUserDetails = async () => {
   emits('goToUserDetails')
}


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('bauDoTesouro.treasure')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "treasureTopImage",
                src: _ctx.dataSet.bannerIcon,
                alt: ""
              }, null, 8, _hoisted_2)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_row, { class: "secContainer" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[0] || (_cache[0] = _createElementVNode("img", {
                    style: {"width":"100%","position":"relative"},
                    src: _imports_0,
                    alt: ""
                  }, null, -1)),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('common.myLink')), 1),
                  _createVNode(InputField, {
                    class: "inputFieldOverlay",
                    modelValue: _ctx.dataSet.activityConfig?.link
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('common.quickShare')), 1),
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mediaList.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "mediaList",
                        onClick: goToShare,
                        style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","padding":"8px"}
                      }, [
                        _createElementVNode("img", {
                          src: item.icon,
                          style: {"height":"24.75px","width":"24.75px"},
                          class: "",
                          alt: ""
                        }, null, 8, _hoisted_8),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t(item.name)), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", {
                  onClick: goToUserDetails,
                  style: {"margin-top":"15px","background":"linear-gradient(180deg, rgba(240,168,83,0.25) 0%, rgba(240,168,83,0.25) 100%)","border-radius":"10px"}
                }, [
                  _createVNode(_component_van_row, { style: {"padding":"0px 10px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, { span: "15" }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('bauDoTesouro.myReports')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "7",
                        style: {"color":"#F0A853","font-size":"13.98px","display":"flex","justify-content":"flex-end","flex-direction":"row"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.dataSet.activityConfig?.valid_user_count), 1),
                          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('common.pepole')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "2",
                        style: {"display":"flex","justify-content":"flex-end","align-items":"center"}
                      }, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createElementVNode("img", {
                            style: {"height":"24.75px","width":"24.75px"},
                            src: _imports_1,
                            alt: ""
                          }, null, -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_van_row, {
                    gutter: "10",
                    justify: "center"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zigzagReordered.value, (item, index) => {
                        return (_openBlock(), _createBlock(_component_van_col, {
                          key: index,
                          span: "6",
                          style: {"text-align":"center"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(RewardBox, {
                              peopleCount: item.valid_count,
                              reward: item.reward,
                              side: item.side,
                              down: item.turnDown,
                              isInCorner: item.isInCorner,
                              received: item?.received,
                              isLast: item.isLast
                            }, null, 8, ["peopleCount", "reward", "side", "down", "isInCorner", "received", "isLast"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_van_row, { style: {"padding-bottom":"10px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "6",
              class: ""
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("div", { class: "line1" }, null, -1)
              ])),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "12",
              class: "title"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("common.activityTitle")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "6",
              class: ""
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "line2" }, null, -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.descriptionHtml, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "line_text",
            key: index
          }, _toDisplayString(item), 1))
        }), 128))
      ])
    ])
  ], 64))
}
}

})